<template>
	<vx-card no-shadow>
		<template slot="actions">
			<div class="w-full flex flex-wrap justify-between" v-if="!eventFinish">
				<div class="flex flex-wrap justify-end">
					<vs-button
						v-show="activeView > 0"
						:title="$t('Resource.BackButton')"
						:size="buttonSize"
						icon-pack="feather"
						icon="icon-arrow-left"
						color="dark"
						class="mr-1"
						type="flat"
						@click="activeView = activeView - 1"
						>{{ $t("Resource.BackButton") }}
					</vs-button>
				</div>
				<div class="flex flex-wrap justify-end">
					<vs-button
						v-if="updateMode && calendarDeletePermission && eventStarted"
						:size="buttonSize"
						color="dark"
						class="vs-con-loading__container mr-1"
						id="btn-change-with-loading"
						@click="changeStatusEvent"
						>{{ $t("Schedule.Finalize") }}
					</vs-button>

					<vs-button
						v-if="updateMode && calendarDeletePermission && !eventStarted"
						:size="buttonSize"
						:title="$t('Schedule.CancelVisit')"
						icon-pack="feather"
						icon="icon-trash-2"
						color="danger"
						class="vs-con-loading__container mr-1"
						id="btn-del-with-loading"
						@click="removeEvent"
						type="flat"
						>{{ $t("Schedule.CancelVisit") }}</vs-button
					>
					<vs-button
						v-if="updateMode && calendarUpdatePermission && !eventStarted"
						:size="buttonSize"
						color="dark"
						icon="icon-save"
						icon-pack="feather"
						class="vs-con-loading__container mr-1"
						id="btn-save-with-loading"
						@click="editEvent"
						:disabled="!validFormUpdate"
						:title="$t('Object.SaveChanges')"
						>{{ $t("Save") }}
					</vs-button>

					<vs-button
						v-if="!updateMode && currentVisitPointId && activeView === 1"
						:size="buttonSize"
						color="dark"
						icon-pack="feather"
						icon="icon-plus-square"
						class="mr-1"
						@click="addEvent(true)"
						:disabled="!validForm"
						type="flat"
						:title="$t('AddNew2')"
						radius
					></vs-button>
					<vs-button
						v-if="!updateMode && unsavedEvents.length > 0 && activeView === 2"
						:size="buttonSize"
						color="danger"
						icon-pack="feather"
						icon="icon-x"
						class="mr-2"
						@click="cancelMulti"
						:title="$t('Cancel')"
						type="flat"
						>{{ $t("Cancel") }}
					</vs-button>

					<vs-button
						v-if="!updateMode && unsavedEvents.length <= 0 && activeView <= 1"
						:size="buttonSize"
						color="dark"
						class="vs-con-loading__container ml-2"
						id="btn-save-with-loading"
						@click="addEvent(false)"
						icon-pack="feather"
						icon="icon-save"
						:disabled="!validForm"
						>{{ $t("Schedule.CreateVisit") }}
					</vs-button>

					<vs-button
						v-if="!updateMode && unsavedEvents.length > 0 && activeView === 2"
						:size="buttonSize"
						color="dark"
						class="vs-con-loading__container"
						id="btn-save-with-loading"
						@click="addMultiEvent"
						:disabled="!validForm"
						icon-pack="feather"
						icon="icon-save"
						:title="unsavedEvents.length > 1 ? $t('Schedule.CreateVisits') : $t('Schedule.CreateVisit')"
						>{{
							windowWidth >= 620
								? unsavedEvents.length > 1
									? $t("Schedule.CreateVisits")
									: $t("Schedule.CreateVisit")
								: ""
						}}
					</vs-button>

					<vs-button
						:size="buttonSize"
						v-show="unsavedEvents.length > 0 && activeView === 1"
						icon-pack="feather"
						icon="icon-calendar"
						color="dark"
						class="mr-1"
						:title="$t('Schedule.ReviewVisits')"
						@click="activeView = 2"
						type="flat"
						>{{ windowWidth >= 620 ? $t("Schedule.ReviewVisits") : "" }}
					</vs-button>
				</div>
			</div>
		</template>

		<transition name="slide-fade">
			<div v-show="activeView === 0">
				<!-- <vue-perfect-scrollbar class="scroll-area--content-left" :settings="settings"> -->
				<vx-card card-border class="mb-base" :title="$t('Information')">
					<div class="vx-row">
						<div class="vx-col w-full lg:w-1/2 mb-2">
							<small class="g-label">{{ $t("Activity.Activity") }}</small>
							<v-select
								id="select-activity"
								:closeOnSelect="true"
								:clearable="false"
								:class="{'vs-con-loading__container': enableClassLoading}"
								:disabled="updateMode || eventFinish"
								v-model="selectedActivityLocal"
								:options="activities"
								:dir="$vs.rtl ? 'rtl' : 'ltr'"
							>
								<template v-slot:no-options="{search, searching}">
									<template v-if="searching">
										{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
									</template>
								</template>
							</v-select>
						</div>

						<div class="vx-col w-full lg:w-1/2 mb-2" v-if="!updateMode">
							<small class="g-label">{{ $t("Schedule.Repeat") }}</small>
							<v-select
								class="w-full"
								:closeOnSelect="true"
								:multiple="enableMultiple"
								v-model="repeat"
								:options="repeat_options"
								:dir="$vs.rtl ? 'rtl' : 'ltr'"
								:disabled="eventFinish"
								@input="setSelected"
							>
								<template v-slot:no-options="{search, searching}">
									<template v-if="searching">
										{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
									</template>
								</template>
							</v-select>
						</div>
					</div>
					<div class="vx-row">
						<div class="vx-col w-full lg:w-1/2 mb-2">
							<small class="g-label">{{ $t("InitDate") }}</small>
							<datepicker
								:language="$vs.rtl ? langHe : langEn"
								name="start-date"
								:disabledDates="disabledDatesFrom"
								v-model="startDate"
								:disabled="eventFinish"
							></datepicker>
						</div>

						<div class="vx-col w-full lg:w-1/2 mb-2" v-show="toogleEndDate">
							<small class="g-label">{{ $t("EndDate") }}</small>
							<datepicker
								:language="$vs.rtl ? langHe : langEn"
								:disabledDates="disabledDatesTo"
								name="end-date"
								v-model="endDate"
								:disabled="eventFinish"
							></datepicker>
						</div>
					</div>
					<div class="vx-row">
						<div class="vx-col w-full lg:w-1/2 mb-2">
							<small class="g-label">{{ $t("InitHour") }}</small>

							<flat-pickr
								:config="configdateTimePicker"
								class="w-full"
								v-model="init_hour"
								name="init_hour"
								:placeholder="$t('Schedule.SelectInitTime')"
								:disabled="selectedActivityLocal.value <= 0 || eventFinish"
							/>

							<span class="text-danger text-sm" v-show="init_hour_error">{{
								$t("Schedule.ErrorProcess.InitHourError")
							}}</span>
						</div>

						<div class="vx-col w-full lg:w-1/2 mb-4">
							<small class="g-label">{{ $t("EndHour") }}</small>

							<flat-pickr
								:config="configdateTimePicker"
								v-model="end_hour"
								class="w-full"
								:placeholder="$t('Schedule.SelectEndTime')"
								v-validate="'truthy'"
								name="end_hour"
								:disabled="eventFinish"
							/>

							<span class="text-danger text-sm" v-show="errors.has('end_hour')">{{
								$t("Schedule.ValidEndOur")
							}}</span>
						</div>
					</div>
				</vx-card>

				<template>
					<vx-card
						:title="$t('Schedule.CurrentVisitPointAssigned')"
						:cardBorder="true"
						v-if="updateMode"
						class="mb-base"
					>
						<vs-list>
							<vs-list-item
								:title="visitPointRelated !== null ? visitPointRelated.name : '' | capitalize"
								:subtitle="visitPointRelatedInfo | capitalize"
							>
								<template slot="avatar">
									<map-pin-icon size="2x" color="primary" class="mr-4"></map-pin-icon>
								</template>
								<vs-button
									color="primary"
									icon-pack="feather"
									icon="icon-search"
									@click="openVisitPointSearch"
									:disabled="eventFinish"
								></vs-button>
							</vs-list-item>
						</vs-list>
					</vx-card>

					<vx-card
						content-color="'secondary'"
						:cardBorder="true"
						:title="cardTitle('ASSIGN_VP')"
						class="mb-base"
						v-else
					>
						<vs-list>
							<vs-list-item
								:title="currentVisitPointId > 0 ? currentVisitPointName : $t('VisitPoint') | capitalize"
								:subtitle="
									currentVisitPointId > 0
										? currentVisitPointInfo
										: $t('Schedule.ToAssigVisitPoint') | title
								"
							>
								<template slot="avatar">
									<map-pin-icon size="2x" color="primary" class="mr-4"></map-pin-icon>
								</template>
								<vs-button
									:color="visitPointHasError ? 'danger' : 'primary'"
									icon-pack="feather"
									icon="icon-search"
									@click="openVisitPointSearch"
									:disabled="!validForm"
									:title="buttonTitle('SEARCH_VP')"
								></vs-button>
							</vs-list-item>
						</vs-list>

						<span class="text-danger text-sm" v-show="currentVisitPointId <= 0 && visitPointHasError">{{
							$t("Schedule.AssignVisitPointText")
						}}</span>
					</vx-card>
				</template>
				<vx-card
					class="mb-base"
					card-border
					:title="$t('Schedule.AdditionalFields')"
					:subtitle="$t('Schedule.AdditionalFieldsAlert')"
				>
					<div class="vx-col w-full lg:w-1/2 mb-2">
						<small class="g-label">{{ $t("Type") }}</small>
						<v-select
							id="select-category"
							v-model="selectedCategory"
							:placeholder="$t('Select')"
							:class="{'vs-con-loading__container': enableClassLoading}"
							:disabled="categories.length <= 0 || eventFinish"
							:options="categoriesOptions"
							:dir="$vs.rtl ? 'rtl' : 'ltr'"
						>
							<template v-slot:no-options="{search, searching}">
								<template v-if="searching">
									{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
								</template>
							</template>
						</v-select>
					</div>
					<div v-if="dinamicFields.length > 0 && selectedCategory !== null">
						<dinamic-fields
							ref="DinamicFields"
							:additionalFields="dinamicFields"
							:additionalInfo="additional_info"
							:category="selectedCategory.category"
							vx_col_class="vx-col md:w-1/1 w-full mt-2"
						></dinamic-fields>
					</div>
					<div v-if="updateMode && selectedCategory === null">
						<div v-for="(v, key) in additional_info" :key="key">
							<vs-input class="w-full mt-2" :label="key" :value="v" disabled />
						</div>
					</div>
				</vx-card>
			</div>
		</transition>

		<transition name="slide-fade">
			<vx-card v-show="activeView === 1" :title="cardTitle('ASSIGN_VP')" card-border>
				<visit-point-list
					v-if="fullscreen"
					:customConfig="visitPointListConfig"
					:relatedIds="relatedIds"
					:resource_id="rid"
					ref="VisitPointList"
					:componentParent="parentComponent"
					:drPointsActivity="drPointsActivity"
				>
					<vx-card ref="filterCard" :title="$t('Filters')" class="user-list-filters mb-8" no-shadow>
						<template slot="actions">
							<div class="flex flex-wrap justify-end">
								<template>
									<vs-button
										v-if="windowWidth > 620"
										:size="iconSize"
										type="flat"
										:title="$t('Search')"
										icon-pack="feather"
										icon="icon-search"
										color="dark"
										@click="searchVisitPointFilterCategory"
										>{{ $t("Search") }}
									</vs-button>
									<vs-button
										v-else
										:size="iconSize"
										type="flat"
										:title="$t('Search')"
										icon-pack="feather"
										icon="icon-search"
										color="dark"
										@click="searchVisitPointFilterCategory"
									>
									</vs-button>
								</template>
								<template>
									<vs-button
										v-if="windowWidth > 620"
										:size="iconSize"
										type="flat"
										:title="$t('Schedule.Refresh')"
										icon-pack="feather"
										icon="icon-refresh-cw"
										color="dark"
										@click="refres"
										>{{ $t("Schedule.Refresh") }}</vs-button
									>
									<vs-button
										v-else
										:size="iconSize"
										type="flat"
										:title="$t('Schedule.Refresh')"
										icon-pack="feather"
										icon="icon-refresh-cw"
										color="dark"
										@click="refres"
									></vs-button>
								</template>
							</div>
						</template>

						<div class="vx-row">
							<div class="vx-col w-full md:w-1/2">
								<label class="vs-input--label">{{ $t("SearchBy") }}</label>
								<v-select
									v-model="searchField"
									:clearable="false"
									:options="searchOptions"
									name="country"
									:dir="$vs.rtl ? 'rtl' : 'ltr'"
									class="md:mb-1 mb-4"
								>
									<template v-slot:no-options="{search, searching}">
										<template v-if="searching">
											{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
										</template>
									</template>
								</v-select>
							</div>

							<div class="vx-col w-full md:w-1/2" v-if="searchField.value === 'notSchedule'">
								<div class="vx-row">
									<div class="vx-col w-1/2" v-show="searchField.value === 'notSchedule'">
										<label class="text-sm opacity-75">{{ $t("InitDate") }}</label>
										<datepicker
											:language="$vs.rtl ? langHe : langEn"
											class="w-full"
											name="start-date"
											v-model="startDateFilter"
										></datepicker>
									</div>
									<div class="vx-col w-1/2" v-show="searchField.value === 'notSchedule'">
										<label class="text-sm opacity-75">{{ $t("EndDate") }}</label>
										<datepicker
											:language="$vs.rtl ? langHe : langEn"
											class="w-full"
											:disabledDates="disabledDatesTo"
											name="end-date"
											v-model="endDateFilter"
										></datepicker>
									</div>
								</div>
							</div>

							<div class="vx-col w-full md:w-1/2" v-else>
								<div class="vx-row">
									<div class="vx-col w-full md:w-1/1" v-if="searchField.value === 'AdditionalFields'">
										<div class="vx-row">
											<div class="vx-col w-full md:w-2/3">
												<label class="vs-input--label">{{
													$t("VisitPointObject.Create.SelectObjectType")
												}}</label>
												<v-select
													v-model="additionalField"
													:clearable="false"
													:options="categoriesVisitPoint"
													name="country"
													:dir="$vs.rtl ? 'rtl' : 'ltr'"
													value="typology_name"
													label="typology_name"
													class="w-full"
												>
													<template v-slot:no-options="{search, searching}">
														<template v-if="searching">
															{{ $t("general.NoResultsFoundFor") + " "
															}}<em>{{ search }}</em>
														</template>
													</template>
												</v-select>
											</div>
											<div class="vx-col w-full md:w-1/3 md:mt-1 mt-4">
												<label class="vs-input--label">{{
													$t("Preferences.FindExactly")
												}}</label>
												<vs-switch class="mt-2" color="success" v-model="exact_values" />
											</div>
										</div>
									</div>
									<div class="vx-col w-full md:w-1/1" v-else>
										<vs-input
											:placeholder="$t('Search')"
											v-model="searchQuery"
											@keyup.enter="searchVisitPointFilterCategory"
											class="w-full mt-2 md:mt-6"
										/>
									</div>
								</div>
							</div>
						</div>

						<dinamic-fields
							v-if="additionalField"
							ref="DinamicFields"
							:additionalFields="model"
							:additionalInfo="additional_info"
							:category="additionalField"
							class="mt-4"
						></dinamic-fields>
					</vx-card>
				</visit-point-list>
			</vx-card>
		</transition>

		<transition name="slide-fade">
			<div v-if="activeView === 2 && unsavedEvents.length > 0">
				<vue-perfect-scrollbar class="scroll-area--content-left" :settings="settings">
					<vs-table :data="unsavedEvents" stripe>
						<template slot="thead">
							<vs-th>No</vs-th>
							<vs-th>{{ $t("Activity.Activity") }}</vs-th>
							<vs-th>{{ $t("VisitPoint") }}</vs-th>
							<vs-th>{{ $t("InitHour") }}</vs-th>
							<vs-th></vs-th>
						</template>

						<template slot-scope="{data}">
							<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
								<vs-td :data="indextr">
									{{ indextr + 1 }}
								</vs-td>
								<vs-td :data="tr.activity_name">
									{{ tr.activity_name }}
								</vs-td>
								<vs-td :data="tr.visit_point_name">
									{{ tr.visit_point_name }}
								</vs-td>
								<vs-td :data="indextr">
									{{ tr.init_hour }}
								</vs-td>
								<vs-td :data="tr.website">
									<vs-button
										type="border"
										size="small"
										icon-pack="feather"
										icon="icon-trash-2"
										color="danger"
										:title="$t('Crud.Delete')"
										@click="removeUnsaveEvents(indextr)"
									></vs-button>
								</vs-td>
							</vs-tr>
						</template>
					</vs-table>
				</vue-perfect-scrollbar>
			</div>
		</transition>
	</vx-card>
</template>

<script>
import {CalendarView, CalendarViewHeader} from "vue-simple-calendar";
import {Validator} from "vee-validate";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Datepicker from "vuejs-datepicker";
import {en, es} from "vuejs-datepicker/src/locale";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";

require("vue-simple-calendar/static/css/default.css");

import DinamicFields from "@/components/DinamicFields/DinamicFields.vue";
import VisitPointList from "../visit-point/list/VisitPointList.vue";

// Store
import moduleActivity from "@/store/activity/moduleActivity.js";
import moduleSchedule from "@/store/schedule/moduleSchedule.js";
import moduleVisitPoint from "@/store/visit-point/moduleVisitPoint.js";
import moduleResource from "@/store/resource/moduleResource.js";
import moduleCommon from "@/store/common/moduleCommon.js";

import Event from "@/models/Event.js";

import DateUtils from "@/helpers/DateUtils.js";
import Commons from "@/helpers/commons.js";
import CalendarSidebar from "./CalendarSidebar";
import CalendarAddEvent from "./CalendarAddEvent";

import {dict} from "./messageValidator.js";
import {BatteryChargingIcon, BatteryIcon, WifiIcon, CalendarIcon, MapPinIcon} from "vue-feather-icons";

// register custom messages
Validator.localize("en", dict);

export default {
	props: {
		dataEvent: {
			type: Object,
			default: () => {},
		},
		day: {
			type: Date,
			default: () => new Date(),
		},
		parentComponent: {
			type: String,
			default: "calendar",
		},
		drPoints: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		CalendarView,
		CalendarViewHeader,
		Datepicker,
		flatPickr,
		vSelect,
		VisitPointList,
		CalendarSidebar,
		CalendarAddEvent,
		VuePerfectScrollbar,
		BatteryChargingIcon,
		BatteryIcon,
		WifiIcon,
		CalendarIcon,
		DinamicFields,
		MapPinIcon,
	},
	data() {
		return {
			event: new Event({}),
			showDate: new Date(),
			numberDaysInMont: 30,
			disabledFrom: false,
			updateMode: false,
			id: 0,
			address: "",
			city: "",
			startDate: "",
			endDate: "",
			labelLocal: "none",
			langHe: es,
			langEn: en,
			url: "",
			calendarView: "month",
			activePromptAddEvent: false,
			activePromptEditEvent: false,
			calendarViewTypes: [
				{
					label: this.$t("Schedule.Month"),
					val: "month",
				},
				{
					label: this.$t("Schedule.Week"),
					val: "week",
				},
				{
					label: this.$t("Schedule.Day"),
					val: "day",
				},
			],
			init_hour: null,
			init_hour_error: false,
			end_hour: null,
			configdateTimePicker: {
				enableTime: true,
				enableSeconds: true,
				noCalendar: true,
			},
			selectedActivity: {value: 0, label: this.$t("Select")},
			active: false,
			addNewDataSidebar: false,
			avatar: require("@/assets/images/portrait/small/avatar-s-12.jpg"),
			// Repeat select
			repeat: [{label: this.$t("Schedule.None"), value: "NONE"}],
			repeatFormatString: "NONE",
			repeatOptions: [
				{label: this.$t("Schedule.None"), value: "NONE"},
				{label: this.$t("Schedule.WeekMayus"), value: "WEEK"},
				{label: this.$t("Schedule.MonthMayus"), value: "MONTH"},
				{label: this.$t("Schedule.EveryDay"), value: "MO|TU|WE|TH|FR|SA|SU"},
				{label: this.$t("Schedule.MondayToFriday"), value: "MO|TU|WE|TH|FR"},
				{label: this.$t("Schedule.Monday"), value: "MO"},
				{label: this.$t("Schedule.Tuesday"), value: "TU"},
				{label: this.$t("Schedule.Wednesday"), value: "WE"},
				{label: this.$t("Schedule.Thursday"), value: "TH"},
				{label: this.$t("Schedule.Friday"), value: "FR"},
				{label: this.$t("Schedule.Saturday"), value: "SA"},
				{label: this.$t("Schedule.Sunday"), value: "SU"},
			],
			// config loading button
			backgroundLoading: "primary",
			backgroundLoadingDel: "danger",
			colorLoading: "#fff",
			//Config Visit Point List
			visitPointListConfig: {
				rowSelection: "single", // multiple | single
				activeCheckbox: true,
				activeHeaderCheckboxSelection: false,
				activeLink: false,
				columns: [
					"id",
					"name",
					"identification",
					"address",
					"city",
					"typology_name",
					"status_name",
					"additional_info",
				],
				tableOptions: false,
				showItemsPerPage: false,
				showSearch: false,
				showActions: false,
			},
			// Id list for default checks
			relatedIds: [],
			visitPointRelated: null,
			fullscreen: false,
			colors: {
				agendado: "#28C76F",
				reprogramado: "#006EFF",
				cancelado: "#FF0000",
				finalizado: "#19663b",
				en_proceso: "#FF9F43",
			},
			visitPointHasError: false,
			enableClassLoading: false,
			categories: [],
			selectedCategory: null,
			additional_info: {},
			additional_info_new: {},
			dinamicFields: [],
			activeAlert: true,
			// perfectscrollbar settings
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			enableMultiple: true,
			drPointsActivity: 0,
			infoView: true,
			visitPointView: false,
			showUnsavedEvents: false,
			activeView: 0,
			// For additional filters
			searchQuery: "",
			visit_point_nav: 0,
			visit_point_selected: [],
			searchField: {value: "Name", label: this.$t("Name")},
			dataSelect: [],
			additionalField: null,
			model: null,
			additional_info: {},
			status_id: [],
			exact_values: false,

			startDateFilter: new Date(),
			endDateFilter: new Date(),
		};
	},
	computed: {
		toogleEndDate() {
			return !this.updateMode && !this.repeat.some((r) => r.value === "NONE");
		},
		title_events() {
			return function (data) {
				return data.activity_name;
			};
		},
		subtitle_events() {
			return function (data) {
				return this.$t("VisitPoint") + data.visit_point_name;
			};
		},
		date_events() {
			return function (data) {
				return this.$t("InitDate") + ": " + data.init_date + " " + this.$t("InitHour") + ": " + data.init_hour;
			};
		},
		eventFinish() {
			return this.event.event_status_id === 7;
		},
		eventStarted() {
			return this.event.event_status_id === 6;
		},
		calendarDeletePermission() {
			return this.$store.getters.checkPermission("CALENDAR_D");
		},
		calendarUpdatePermission() {
			return this.$store.getters.checkPermission("CALENDAR_U");
		},
		dateInitComputed: {
			get() {
				return DateUtils.toDefaultDateTime(this.showDate, "YYYY-MM-DD");
			},
			set(val) {},
		},
		dateFinalComputed: {
			get() {
				const dateFinalMilisecods = this.addDaysToDate(this.dateInitComputed, this.numberDaysInMont);
				const dateFinal = DateUtils.toDefaultDateTime(new Date(dateFinalMilisecods), "YYYY-MM-DD");
				return dateFinal;
			},
			set(val) {},
		},
		categoriesOptions() {
			return this.categories.map((c) => ({
				label: c.typology_name,
				value: c.category_id,
				category: c,
			}));
		},
		visitPointRelatedInfo() {
			return this.visitPointRelated !== null
				? this.visitPointRelated.address + " " + this.visitPointRelated.city
				: "";
		},
		currentVisitPointId() {
			const currentVisitPoint = this.$store.getters["moduleVisitPoint/getCurrentVisitPoint"];
			if (currentVisitPoint.hasOwnProperty("id")) {
				return currentVisitPoint.id;
			} else {
				return 0;
			}
		},
		currentVisitPointName() {
			const currentVisitPoint = this.$store.getters["moduleVisitPoint/getCurrentVisitPoint"];
			if (currentVisitPoint.hasOwnProperty("name")) {
				return currentVisitPoint.name;
			} else {
				return "";
			}
		},
		currentVisitPointInfo() {
			const currentVisitPoint = this.$store.getters["moduleVisitPoint/getCurrentVisitPoint"];
			if (currentVisitPoint.hasOwnProperty("name")) {
				return currentVisitPoint.address + " " + currentVisitPoint.city;
			} else {
				return "";
			}
		},
		currentResourceFirstname() {
			const currentResource = this.$store.getters["moduleSchedule/getCurrentResource"];
			if (currentResource.hasOwnProperty("name")) {
				return currentResource.name;
			} else {
				return "";
			}
		},
		currentResourceLastname() {
			const currentResource = this.$store.getters["moduleSchedule/getCurrentResource"];
			if (currentResource.hasOwnProperty("lastname")) {
				return currentResource.lastname;
			} else {
				return "";
			}
		},
		currentResourceEmail() {
			const currentResource = this.$store.getters["moduleSchedule/getCurrentResource"];
			if (currentResource.hasOwnProperty("email")) {
				return currentResource.email;
			} else {
				return "";
			}
		},
		rid() {
			return !this.$store.state.moduleSchedule ? 0 : this.$store.state.moduleSchedule.currentResourceId;
		},
		activities() {
			// Las actividades tienen un array de los recursos asignados
			// Filtras las actividades que tiene el recurso avtual asignada
			let resourceAct = [];
			if (this.parentComponent === "calendar") {
				// ! @bug: filtrar por las actividades que el recurso tiene aginadas
				resourceAct = this.$store.state.moduleActivity.activities.filter((act) =>
					Array.isArray(act.resource_id) ? act.resource_id.some((id) => id === this.rid) : false
				);
			} else if (this.parentComponent === "ON_DEMAND") {
				resourceAct = this.$store.state.moduleActivity.activities;
			}

			return this.generateOptionSelect(resourceAct, "name", "id");
		},
		selectedActivityLocal: {
			get() {
				return {
					value: this.selectedActivity.value,
					label: this.selectedActivity.label,
				};
			},
			set(val) {
				this.selectedActivity = {...val};
			},
		},
		simpleCalendarEvents() {
			if (!this.$store.state.moduleSchedule.events) {
				return [];
			}
			const events = this.$store.state.moduleSchedule.events;
			return events.map((event) => {
				const date = new Date(event.date_prog);
				const parseDate = date.setDate(date.getDate() + 1);
				return {
					/* id: 1,
            title: 'My Event',
            startDate: new Date(new Date() - 1000 * 60 * 60 * 24 * 3),
            endDate: new Date(new Date() - 1000 * 60 * 60 * 24 * 2),
            url: '',
            classes: 'event-success',
            label: 'business'
          */
					id: event.init_hour + event.id,
					title: `${event.init_hour} ${event.activity_name}`,
					startDate: parseDate,
					endDate: parseDate,
					url: "",
					classes: "event-" + this.labelColor(event.event_status_id),
					label: "business",
				};
			});
		},
		validForm() {
			return (
				this.selectedActivityLocal.value > 0 &&
				this.init_hour !== null &&
				this.end_hour !== null &&
				this.startDate !== "" &&
				this.endDate !== "" &&
				Date.parse(this.endDate) - Date.parse(this.startDate) >= 0 &&
				!this.errors.has("end_hour")
			);
		},
		validFormUpdate() {
			return (
				this.selectedActivityLocal.value > 0 &&
				this.init_hour !== null &&
				this.end_hour !== null &&
				this.startDate !== "" &&
				Date.parse(this.startDate) - new Date() >= 0
			);
		},
		disabledDatesTo() {
			return {to: new Date(this.startDate)};
		},
		disabledDatesFrom() {
			return {to: new Date()};
		},
		calendarLabels() {
			return this.$store.state.moduleSchedule.eventSatusLabels;
		},
		labelColor() {
			return (label) => {
				if (label === 8) return this.$t("Schedule.Finished");
				else if (label === 9) return this.$t("Schedule.InProgress");
				else if (label === 5) return this.$t("Schedule.ReProgramming");
				else if (label === 4) return this.$t("Schedule.Canceled");
				else if (label === 2) return this.$t("Schedule.Scheduled");
			};
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		unsavedEvents() {
			return this.$store.state.moduleSchedule.unsavedEvents;
		},
		repeat_options() {
			return this.repeatOptions;
		},
		enableVisitPointSelection() {
			return this.selectedActivityLocal.value <= 0;
		},
		categoriesVisitPoint() {
			return this.$store.state.moduleCommon.dataSelectVisitPoint.category;
		},

		iconSize() {
			return this.$store.state.windowWidth < 620 ? "small" : "medium";
		},

		searchOptions() {
			return [
				{value: "Name", label: this.$t("Name")},
				{value: "Identification", label: this.$t("Identification")},
				{value: "Address", label: this.$t("Address")},
				{value: "City", label: this.$t("City")},
				{
					value: "AdditionalFields",
					label: this.$t("Object.AdditionalFields"),
				},
				{
					value: "notSchedule",
					label: this.$t("VisitPointObject.List.NotSchedule"),
				},
			];
		},
		disabledDatesTo() {
			return {to: new Date(this.startDate)};
		},
		disabledDatesFrom() {
			return {to: new Date()};
		},
		buttonSize() {
			return this.windowWidth < 620 ? "small" : "medium";
		},
		buttonTitle() {
			return function (params) {
				const obj = {
					SEARCH_VP: `${this.$t("Search")} ${this.$t("VisitPoint")}`,
				};
				return obj[params] ? obj[params] : "";
			};
		},
		cardTitle() {
			return function (params) {
				const obj = {
					ASSIGN_VP: `${this.$t("VisitPointObject.Assig")} ${this.$t("VisitPoint")}`,
				};
				return obj[params] ? obj[params] : "";
			};
		},
	},
	methods: {
		setSelected(selections) {
			if (Array.isArray(selections)) {
				const lastSelected = selections[selections.length - 1];
				if (!lastSelected) {
					this.repeat = [{label: this.$t("Schedule.None"), value: "NONE"}];
					return;
				}
				if (
					lastSelected.value === "MO" ||
					lastSelected.value === "TU" ||
					lastSelected.value === "WE" ||
					lastSelected.value === "TH" ||
					lastSelected.value === "FR" ||
					lastSelected.value === "SA" ||
					lastSelected.value === "SU"
				) {
					const filter = selections.filter(
						({value}) =>
							value === "MO" ||
							value === "TU" ||
							value === "WE" ||
							value === "TH" ||
							value === "FR" ||
							value === "SA" ||
							value === "SU"
					);
					this.repeat = filter;
				} else {
					//this.enableMultiple = false;
					this.repeat = [lastSelected];
				}
			}
		},
		openVisitPointSearch() {
			this.fullscreen = true;
			this.activeView = 1;
			//this.$emit("fullscreenChangeEmit", true);
		},
		closeVisitPointSearch() {
			this.fullscreen = true;
			//this.$emit("fullscreenChangeEmit", false);
		},
		close() {
			this.$refs.CalendarSidebar.toggleDataSidebar(false);
		},
		// Funcion para agregar días a una fecha parseada desde un String, ya que cuendo se crea
		// dicha fecha siempre toma un día menos
		addDaysToDate(stringDate, dayNums) {
			// 1000 * 60 * 60 * 24 * 3
			const date = new Date(stringDate);
			return date.setDate(date.getDate() + dayNums);
		},
		changeCalendarViewTypes(typeView) {
			this.calendarView = typeView;
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		openLoadingButton(btnId, backgroundLoading = this.backgroundLoading) {
			this.$vs.loading({
				background: backgroundLoading,
				color: this.colorLoading,
				container: btnId,
				scale: 0.45,
			});
		},
		closeLoadingButton(btnId) {
			this.$vs.loading.close(btnId + " > .con-vs-loading");
		},
		openLoadingInDivContent() {
			this.$vs.loading({
				container: "#resource-calendar-with-loading",
				scale: 0.6,
			});
		},
		closeLoadingInDivContent() {
			this.$vs.loading.close("#resource-calendar-with-loading > .con-vs-loading");
		},
		generateOptionSelect(data, propLabel, propValue) {
			let newData = [];
			if (this.parentComponent === "ON_DEMAND") {
				newData = data
					.filter((d) => d.dr_points !== null)
					.map((d) => {
						return {
							label: d[propLabel] + " - DR Points: $ " + (d.dr_points || this.$t("OnDemand.Free")),
							value: d[propValue],
						};
					});
			} else {
				newData = data.map((d) => {
					return {label: d[propLabel], value: d[propValue]};
				});
			}
			newData.unshift({label: this.$t("Select"), value: 0});
			return newData;
		},

		validateForm() {
			return !this.errors.any();
		},
		addEvent(saveOnStore = false) {
			if (this.currentVisitPointId <= 0) {
				this.visitPointHasError = true;
				return;
			}
			if (this.stringTimeToDate(this.end_hour) < this.stringTimeToDate(this.init_hour)) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("Schedule.InvalidFields"),
					text: this.$t("Schedule.ValidEndOur"),
				});
				return;
			}
			const dateI = new Date(this.startDate);
			const dateE = new Date(this.endDate);
			this.event.activity_id = this.selectedActivity.value;
			this.event.init_date = DateUtils.toDefaultDateTime(dateI, "YYYY-MM-DD");
			this.event.end_date = DateUtils.toDefaultDateTime(dateE, "YYYY-MM-DD");
			this.event.init_hour = this.init_hour;
			this.event.end_hour = this.end_hour;
			this.event.repeat = this.repeatFormatString;
			this.event.resource_id = this.rid;
			this.event.visit_point_id = this.currentVisitPointId;
			// recuperamos todas las propiedades adicionales modificadas desde el componente hijo
			if (this.selectedCategory) {
				if (this.$refs.DinamicFields !== undefined) {
					const additional_info = this.$refs.DinamicFields.getAddionalInfo();
					Object.assign(this.event.additional_info, additional_info);
				}
			}
			const payload = {
				events: [this.event.getDataToSave()],
			};
			if (this.parentComponent === "ON_DEMAND") {
				payload.events = [this.event.getDataToSaveOnDemand()];
			}
			this.$validator.validateAll().then((result) => {
				if (result) {
					if (saveOnStore) {
						this.event.activity_name = this.selectedActivity.label;
						this.event.visit_point_name = this.currentVisitPointName;
						this.$store.commit("moduleSchedule/ADD_UNSAVED_EVENT", {
							...this.event,
						});
						this.$refs.VisitPointList.clearSelectedRow();
						// Incrementamos la hora inicial para programar mas eventos
						const currentActivity = this.$store.getters["moduleActivity/getActivityById"](
							this.selectedActivityLocal.value
						);
						const activityTime = currentActivity.service_time;
						const [hours, minutes, seconds] = activityTime.split(":");
						this.init_hour = DateUtils.addHoursMinutesSecodons(
							this.init_hour,
							parseInt(hours),
							parseInt(minutes),
							parseInt(seconds)
						);
					} else {
						this.openLoadingButton("#btn-save-with-loading");
						this.$store
							.dispatch("moduleSchedule/addEvent", payload)
							.then((res) => {
								this.closeLoadingButton("#btn-save-with-loading");
								if (res.hasOwnProperty("error") && res.error.length > 0) {
									this.validateErrorMessages(res.error[0].message);
									return;
								}
								this.$vs.notify({
									color: "success",
									title: this.$t("TitleConfirmEventCreate"),
									text: this.$t("TextConfirmEventCreate"),
								});
								this.clearFields();
								this.$emit("changePopupActiveEmit", {
									active: false,
									refres: true,
								});
							})
							.catch((err) => {
								this.closeLoadingButton("#btn-save-with-loading");
								this.showErrorAlert();
							});
					}
				} else {
					this.$vs.notify({
						color: "danger",
						title: this.$t("Schedule.ValidData.Title"),
						text: this.$t("Schedule.ValidData.Text"),
					});
					this.closeLoadingButton("#btn-save-with-loading");
				}
			});
		},
		addMultiEvent() {
			const payload = {
				events: this.$store.state.moduleSchedule.unsavedEvents.map((event) => new Event(event).getDataToSave()),
			};
			// Si es un evento de tipo ON_DEMAND, se elimina la propiedad resource_id del payload
			if (this.parentComponent === "ON_DEMAND") {
				payload.events = this.$store.state.moduleSchedule.unsavedEvents.map((event) =>
					new Event(event).getDataToSaveOnDemand()
				);
			}
			this.openLoadingButton("#btn-save-with-loading");
			this.$store
				.dispatch("moduleSchedule/addEvent", payload)
				.then((res) => {
					this.closeLoadingButton("#btn-save-with-loading");
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmEventCreate"),
						text: this.$t("TextConfirmEventCreate"),
					});
					this.$store.commit("moduleSchedule/SET_UNSAVED_EVENT", []);
					this.$emit("changePopupActiveEmit", {
						active: false,
						refres: true,
					});
				})
				.catch((err) => {
					this.closeLoadingButton("#btn-save-with-loading");
					this.showErrorAlert();
				});
		},
		validateErrorMessages(message) {
			let text = "";
			switch (message) {
				case "activity not available for the resource":
					text = this.$t("Schedule.ActivityNoAvailable");
					break;
				case "init_hour less than current time":
					text = this.$t("Schedule.ErrorProcess.InitHourError");
					this.init_hour_error = true;
					break;
				case "visit point is not related to resource":
					text = this.$t("Schedule.ErrorProcess.VisitpointError");
					break;
				case "resource has no activities":
					text = this.$t("Schedule.ErrorProcess.ResourceActivityError");
					break;
				default:
					text = this.$t("ErrorMessage");
					break;
			}
			this.$vs.notify({
				time: 4000,
				color: "danger",
				title: this.$t("ErrorTitle"),
				text,
			});
		},
		manageErrorAlert(err) {
			const {title, text} = Commons.manageErrorValidator.call(this, err);
			const findErrorNameProperty = Commons.findErrorNameProperty();
			const nameProperty = findErrorNameProperty(err);
		},
		clearFields() {
			this.endDate = "";
			this.id = 0;
			//this.labelLocal = "none";
			this.init_hour = null;
			this.end_hour = null;
			this.selectedActivity = this.activities[0];
			this.visitPointHasError = false;
			this.$store.dispatch("moduleVisitPoint/currentVisitPointSelected", null);
		},
		cancelMulti() {
			this.$store.commit("moduleSchedule/SET_UNSAVED_EVENT", []);
			this.$refs.VisitPointList.clearSelectedRow();
			this.activeView = 0;
			//this.$emit("changePopupActiveEmit", {active: false, refres: false});
		},
		openEditEvent(event) {
			const e = this.$store.getters["moduleSchedule/getEventByCalendarId"](event.id);
			this.updateMode = true;
			this.id = e.id;
			this.startDate = event.startDate;
			this.endDate = event.startDate;
			this.$validator.pause();
			this.init_hour = e.init_hour;
			this.end_hour = e.end_hour;
			this.address = e.address;
			this.city = e.city;
			this.additional_info = {...e.additional_info};
			this.event = new Event(e);
			const foundActivity = this.activities.find((act) => act.value === e.activity_id);
			this.selectedActivity = !foundActivity ? this.activities[0] : {...foundActivity};
			this.relatedIds = [];
			this.relatedIds.push(e.visit_point_id);
			this.getVisitPointById(e.visit_point_id);
		},
		editEvent() {
			if (this.stringTimeToDate(this.end_hour) < this.stringTimeToDate(this.init_hour)) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("Schedule.InvalidFields"),
					text: this.$t("Schedule.ValidEndOur"),
				});
				return;
			}

			const currentVisitPoint = this.$store.getters["moduleVisitPoint/getCurrentVisitPoint"];

			// Update Required fields for current event
			this.event.event_id = this.id;
			this.event.resource_id = this.rid;
			this.event["date_prog"] = DateUtils.toDefaultDateTime(this.startDate, "YYYY-MM-DD");
			this.event.init_hour = this.init_hour;
			this.event.end_hour = this.end_hour;
			this.event.additional_info = this.additional_info;

			if (this.currentVisitPointId > 0) {
				// Add Optional fields for update visit point related
				this.event.setVisitPointInfo(currentVisitPoint);
			}
			if (this.selectedCategory) {
				// Clear old aditional fields
				for (const key in this.event.additional_info) {
					if (!this.additional_info_new.hasOwnProperty(key)) {
						delete this.event.additional_info[key];
					}
				}
			}
			this.openLoadingButton("#btn-save-with-loading");
			this.$store
				.dispatch("moduleSchedule/editEvent", this.event)
				.then((res) => {
					this.closeLoadingButton("#btn-save-with-loading");
					this.closeLoading();
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmEventUpdate"),
						text: this.$t("TextConfirmEventUpdate"),
					});
					this.clearFields();
					this.$emit("changePopupActiveEmit", {active: false, refres: false});
				})
				.catch((err) => {
					this.closeLoading();
					this.closeLoadingButton("#btn-save-with-loading");
					this.showErrorAlert();
				});
		},
		removeEvent() {
			const obj = {
				events: [{event_id: this.id, resource_id: this.rid}],
			};

			this.openLoadingButton("#btn-del-with-loading", this.backgroundLoadingDel);

			this.$store
				.dispatch("moduleSchedule/removeEvent", obj)
				.then((res) => {
					this.closeLoadingButton("#btn-del-with-loading");
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmEventDelete"),
						text: this.$t("TextConfirmEventDelete"),
					});
					this.clearFields();
					this.$emit("changePopupActiveEmit", {
						active: false,
						refres: false,
					});
				})
				.catch((err) => {
					this.closeLoadingButton("#btn-del-with-loading");
					this.showErrorAlert();
				});
		},
		showErrorAlert() {
			this.$vs.notify({
				color: "danger",
				title: this.$t("Schedule.ErrorProcess.Title"),
				text: this.$t("Schedule.ErrorProcess.Text"),
			});
		},
		async cleanEvents() {
			await this.$store.dispatch("moduleSchedule/cleanEvents");
		},
		formatRepeatValue(days) {
			if (Array.isArray(days)) {
				const letters = days.map((d) => {
					if (d === "TUESDAY" || d === "THURSDAY") {
						return d.substring(0, 2);
					} else {
						return d.substring(0, 1);
					}
				});
				return letters.join("|");
			} else {
				return days;
			}
		},
		getVisitPointById(visitPointId) {
			this.$store
				.dispatch("moduleVisitPoint/fetchVisitPointById", visitPointId)
				.then((res) => {
					this.visitPointRelated = res;
				})
				.catch((err) => {
					if (err.response.status === 404) {
						this.user_not_found = true;
						return;
					}
					console.error(err);
				});
		},
		stringTimeToDate(stringTime) {
			let newDate = new Date();
			if (typeof stringTime === "string") {
				const [hours, minutes, seconds] = stringTime.split(":");
				newDate = new Date(1995, 11, 17, parseInt(hours), parseInt(minutes), parseInt(seconds));
			}
			return newDate;
		},
		validatorInitHour(value, args) {
			return this.stringTimeToDate(value) > this.stringTimeToDate(new Date());
		},
		validatori(value, args) {
			return this.stringTimeToDate(value) > this.stringTimeToDate(this.init_hour);
		},
		fetchDataCategory(category) {
			const payload = {
				role: [],
				category,
				typology: [],
			};
			this.$store
				.dispatch("moduleResource/fetchDataSelect", payload)
				.then((res) => {
					this.categories = res.data.category;
				})
				.catch((error) => {
					console.error(error);
				});
		},
		setDataModelDinamicFields(categoryId) {
			const found = this.categories.find((typology) => typology.category_id === categoryId);
			this.dinamicFields = this.event.dataModelEventDinamicFields(found);
			// Agregar campos dinamicos al objeto danger para el renderizado
			if (this.dinamicFields.length > 0) {
				this.dinamicFields.forEach((m) => {
					this.additional_info_new[m.name] = "";
				});
			}
		},
		removeUnsaveEvents(index) {
			this.$store.commit("moduleSchedule/REMOVE_UNSAVED_EVENT", index);
			if (this.unsavedEvents.length <= 0) {
				this.activeView = 1;
			}
		},
		changeStatusEvent() {
			const event = {
				event_id: this.id,
				resource_id: this.rid,
				event_status_id: 7,
			};
			this.openLoading();
			this.$store
				.dispatch("moduleSchedule/changeStatusEvent", event)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("OnDemand.AssigResource"),
						text: this.$t("OnDemand.ResourcesAssigned"),
					});
					this.closeLoading();
					this.$emit("changePopupActiveEmit", {
						active: false,
						refres: true,
					});
				})
				.catch((err) => {
					this.closeLoading();
					this.validateErrorMessages(err.data.reason);
				});
		},
		searchVisitPointFilterCategory() {
			if (this.$refs.DinamicFields !== undefined && this.searchField.value === "AdditionalFields") {
				// recuperamos todas las propiedades adicionales modificadas desde el componente hijo
				const additional_info = this.$refs.DinamicFields.getAddionalInfo();
				// Formato para buscar por campos adicionales [['property_name', 'property_value']]
				const formatData = Object.entries(additional_info);
				this.$refs.VisitPointList.searchByAdditionalFields(
					[this.additionalField.typology_id],
					formatData,
					1,
					this.exact_values
				);
				return;
			}

			if (this.searchField.value === "notSchedule") {
				this.$refs.VisitPointList.visitPointNotSchedule(this.startDateFilter, this.endDateFilter);
				return;
			}

			this.$refs.VisitPointList.searchResource2(this.searchField.value, this.searchQuery.trim(), 1);
		},
		refres() {
			this.$refs.VisitPointList.refreshVisitPoint();
			this.searchQuery = "";
			this.searchField = {value: "Name", label: this.$t("Name")};
		},
	},
	filters: {
		replaceUnderscore(sentence) {
			return sentence.includes("_") ? sentence.replace("_", " ") : sentence;
		},
	},
	watch: {
		selectedActivity(val) {
			const foundActivity = this.$store.state.moduleActivity.activities.find(
				(activity) => activity.id === val.value
			);
			this.drPointsActivity = foundActivity ? foundActivity.dr_points : 0;
		},
		repeat(repeat) {
			this.repeatFormatString = repeat.map(({value}) => value).join("|");
		},
		fullscreen(val) {
			if (!val) {
				this.clearFields();
			}
		},
		init_hour(val) {
			if (typeof val === "string" && val !== "") {
				const currentActivity = this.$store.getters["moduleActivity/getActivityById"](
					this.selectedActivityLocal.value
				);
				const activityTime = currentActivity.service_time;
				const [hours, minutes, seconds] = activityTime.split(":");
				// startTime , hours, minutes, seconds

				this.end_hour = DateUtils.addHoursMinutesSecodons(
					val,
					parseInt(hours),
					parseInt(minutes),
					parseInt(seconds)
				);
				this.init_hour_error = false;
			}
		},
		currentVisitPointId(val) {
			if (val > 0) {
				this.visitPointHasError = false;
			}
		},
		selectedCategory(val) {
			// Setear modelo de datos para renderizar campos dinamicos
			this.event.additional_info = {};
			this.additional_info_new = {};
			if (val) this.setDataModelDinamicFields(val.value);
		},
		additionalField(obj) {
			this.additional_info = {};
			// this.payloadResource.typology_id = obj.value;
			let dataFields = obj && obj.hasOwnProperty("json_properties") ? obj.json_properties : [];
			dataFields = dataFields.filter((element) => element.name !== "additional_info");
			const updateData = dataFields.map((element) => {
				return {...element, error: false};
			});
			this.model = [...updateData.filter(({additional}) => additional)];
		},
	},
	created() {
		Date.prototype.addMinutes = function (min) {
			this.setTime(this.getTime() + min * 60 * 1000);
			return this;
		};

		Validator.extend("truthy", this.validatori);
		Validator.extend("validatorInitHour", this.validatorInitHour);
		new Validator({trueField: "truthy"}, {trueField: "validatorInitHour"});

		if (!moduleActivity.isRegistered) {
			this.$store.registerModule("moduleActivity", moduleActivity);
			moduleActivity.isRegistered = true;
		}

		if (!moduleSchedule.isRegistered) {
			this.$store.registerModule("moduleSchedule", moduleSchedule);
			moduleSchedule.isRegistered = true;
		}

		// Register Module VisitPoint Module
		if (!moduleVisitPoint.isRegistered) {
			this.$store.registerModule("moduleVisitPoint", moduleVisitPoint);
			moduleVisitPoint.isRegistered = true;
		}

		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}

		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}

		if (this.$store.state.moduleSchedule.eventSatusLabels.length <= 0) {
			this.$store
				.dispatch("moduleSchedule/fetchEventStatusLabel")
				.then((res) => {})
				.catch((err) => {
					console.error(err);
				});
		}

		if (this.parentComponent === "ON_DEMAND") {
			this.visitPointListConfig.tableOptions = false;
		}
	},
	mounted() {
		if (this.$store.state.moduleActivity.activities.length <= 0) {
			this.enableClassLoading = true;
			Commons.openLoadingDiv.call(this, "select-activity");
			this.$store
				.dispatch("moduleActivity/fetchActivityListItems")
				.then((res) => {
					Commons.closeLoadingDiv.call(this, "select-activity");
					this.enableClassLoading = false;
				})
				.catch((err) => {
					Commons.closeLoadingDiv.call(this, "select-activity");
					this.enableClassLoading = false;
					console.error(err);
				});
		}
		// Set number days current month
		this.numberDaysInMont = DateUtils.getNumberOfDaysInSeletedMonth(
			this.showDate.getMonth() + 1,
			this.showDate.getFullYear()
		);
		if (this.dataEvent.hasOwnProperty("id")) {
			this.openEditEvent(this.dataEvent);
		} else {
			this.startDate = this.day;
			this.endDate = this.day;
		}

		this.fetchDataCategory("SCHEDULE");
	},
	beforeDestroy() {
		this.clearFields();
		this.closeVisitPointSearch();
	},
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";

.vs-popup--content-custom {
	.vs-popup--content {
		height: 100%;
	}

	.btn-save {
		position: absolute;
		left: cal(100 vw- 10%);
		bottom: 30px;
	}

	.btn-del {
		position: absolute;
		left: 200px;
		bottom: 30px;
	}
}

.event-form-content {
	min-height: auto;
}

.event-form-content-full {
	min-height: 580px;
	max-height: auto;
}

.scroll-area--data-list-add-new {
	// height: calc(var(--vh, 1vh) * 100 - 4.3rem);
	height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

	&:not(.ps) {
		overflow-y: auto;
	}
}

.scroll-area--content-left {
	margin: auto;
	width: 100%;
	min-height: 500px;
	max-height: 680px;
}
</style>
